export default {
  methods: {
    formatDateToBegining(date){
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      return year+"-"+month+"-"+day + " 00:00:00"
    },
    formatDateToEnd(date){
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      return year+"-"+month+"-"+day + " 23:59:59"
    },
  }
}
